module.exports = __webpack_public_path__ + "static/media/Correct Icon.d0c0e17d.png";